import { Box, Tooltip } from '@mui/material';
import ASSETS from '@siloreal:modules:private/silobag-list/config/extra/assets';
import * as HOOKS from '@siloreal:shared:hooks';

type Translate = (scope: string) => string;

export function getVrrBadgeLabel(ok: boolean, translate: Translate): string {
  return translate(`temp.private.list.silospro.${ok ? 'vrr_ok' : 'vrr_not_ok'}`);
}

export function VrrBadge({ ok }: { ok: boolean }) {
  const i18n = HOOKS.useLocale();
  const tooltip = getVrrBadgeLabel(ok, i18n.t);

  return (
    <Tooltip title={tooltip} placement="top" arrow>
      <Box
        component="span"
        aria-label={tooltip}
        sx={{
          width: 28,
          height: 28,
          flexShrink: 0,
          borderRadius: 2,
          backgroundColor: ok ? '#D4F5C8' : '#FFD4D8',
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          cursor: 'default',
        }}
      >
        {ok ? ASSETS.VRR.OK : ASSETS.VRR.NO_OK}
      </Box>
    </Tooltip>
  );
}
